(() => {
/* Wild Gainz batch reports portal.
   Progressive enhancement: without this script every report card renders in
   Liquid order and the search toolbar stays hidden, so nothing appears
   broken. With it, cards sort newest first and can be narrowed by batch
   number search and flavor pills. */

if (customElements.get('wildgainz-batch-reports')) return;

class WildgainzBatchReports extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-reports-grid]');
    this.cards = Array.from(this.querySelectorAll('[data-reports-card]'));
    this.toolbar = this.querySelector('[data-reports-toolbar]');
    this.search = this.querySelector('[data-reports-search]');
    this.pills = Array.from(this.querySelectorAll('[data-reports-filter]'));
    this.emptyMessage = this.querySelector('[data-reports-empty]');
    this.countStatus = this.querySelector('[data-reports-count]');
    if (!this.grid || this.cards.length === 0) return;

    // The element reconnects when the theme editor moves the section, so
    // listener attachment and filter state must survive a re-run.
    if (this.bound) return;
    this.bound = true;
    this.flavor = '';

    // Newest first. Liquid cannot sort metaobjects by field, so the cards
    // carry their test date as a unix timestamp.
    this.cards
      .slice()
      .sort((a, b) => Number(b.dataset.sort || 0) - Number(a.dataset.sort || 0))
      .forEach((card) => this.grid.appendChild(card));

    if (this.toolbar) this.toolbar.removeAttribute('hidden');
    if (this.search) {
      this.search.addEventListener('input', () => this.apply());
    }
    this.pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        this.flavor = pill.dataset.reportsFilter || '';
        this.pills.forEach((other) => {
          const active = other === pill;
          other.classList.toggle('wg-batch-reports__pill--active', active);
          other.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.apply();
      });
    });
  }

  apply() {
    const query = this.search
      ? this.search.value.trim().toLowerCase().replace(/\s+/g, '')
      : '';
    let visible = 0;

    this.cards.forEach((card) => {
      const batch = (card.dataset.batch || '').replace(/\s+/g, '');
      const matchesQuery = query === '' || batch.indexOf(query) !== -1;
      const matchesFlavor = this.flavor === '' || card.dataset.flavor === this.flavor;
      const show = matchesQuery && matchesFlavor;
      card.classList.toggle('wg-batch-reports__card--hidden', !show);
      if (show) visible += 1;
    });

    if (this.emptyMessage) {
      this.emptyMessage.hidden = visible !== 0;
    }
    // Always-rendered live region: mutating its text is what makes screen
    // readers announce the new result count after a search or filter.
    if (this.countStatus) {
      this.countStatus.textContent = visible + ' ' + (this.dataset.resultsText || '');
    }
  }
}

customElements.define('wildgainz-batch-reports', WildgainzBatchReports);
})();
